document.addEventListener("DOMContentLoaded", function () {
  // Evitar ejecución en dispositivos móviles
  if (window.innerWidth <= 768) return;

  /** ====== SWIPER INIT ====== **/
  window.addEventListener("load", function () {
    new Swiper(".mySwiper", {
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
      },
    });
  });


  const boxes = gsap.utils.toArray(".vs-banner-heading");
  loop = horizontalLoop(boxes, { paused: false, repeat: -1 });

  /** ====== FILTROS DE COLECCIONES ====== **/
  const collections = document.querySelectorAll(".w-dyn-list");
  const filters = document.querySelectorAll(".sublink");

  if (collections.length > 1 && filters.length > 0) {
    collections.forEach((collection, index) => {
      collection.style.display = index === 1 ? "flex" : "none";
    });

    filters.forEach((filter, index) => {
      filter.addEventListener("touchstart ", function (event) {

        // Reset de estilos
        filters.forEach((f) => {
          f.style.fontWeight = "500";
          f.style.color = "#000";
        });

        // Activar filtro seleccionado
        this.style.fontWeight = "700";
        this.style.color = "#e12220";

        const activeFilter = this.dataset.filter;
        collections.forEach((collection, collectionIndex) => {
          collection.style.display =
            (activeFilter === "essall" && collectionIndex === 1) ||
              (activeFilter === "best-sellers" && collectionIndex === 2) ||
              (activeFilter === "new" && collectionIndex === 3) ||
              (activeFilter === "accessories" && collectionIndex === 4) ||
              (activeFilter === "liquidation" && collectionIndex === 5)
              ? "flex"
              : "none";
        });
      });
    });
  }

  /** ====== MANEJO DE HOVER EN TARJETAS ====== **/
  document.addEventListener("mouseover", function (event) {
    const container = event.target.closest(".div-block-70");
    if (!container) return;

    const containerTallas = container.querySelector(".div-block-77");
    const containerInfo = container.querySelector(".div-block-67");

    if (containerTallas && containerInfo) {
      containerTallas.style.opacity = "1";
      containerTallas.style.display = "flex";
      containerInfo.style.opacity = "0";
      containerInfo.style.display = "none";
    }
  });

  document.addEventListener("mouseout", function (event) {
    const container = event.target.closest(".div-block-70");
    if (!container) return;

    const containerTallas = container.querySelector(".div-block-77");
    const containerInfo = container.querySelector(".div-block-67");

    if (containerTallas && containerInfo) {
      containerTallas.style.opacity = "0";
      containerTallas.style.display = "none";
      containerInfo.style.opacity = "1";
      containerInfo.style.display = "flex";
    }
  });

  /** ====== MANEJO DE IMÁGENES EN HOVER ====== **/
  document.addEventListener("mouseover", function (event) {
    const div = event.target.closest(".div-block-70");
    if (!div) return;

    const images = div.querySelectorAll(".image-6");
    if (images.length >= 2) {
      images[0].style.display = "none";
      images[1].style.display = "flex";
    }
  });

  document.addEventListener("mouseout", function (event) {
    const div = event.target.closest(".div-block-70");
    if (!div) return;

    const images = div.querySelectorAll(".image-6");
    if (images.length >= 2) {
      images[0].style.display = "flex";
      images[1].style.display = "none";
    }
  });

  /** ====== CLIC FUERA DE TARJETAS PARA RESET ====== **/
  document.addEventListener("click", function (event) {
    if (!event.target.closest(".div-block-70")) {
      document.querySelectorAll(".div-block-77").forEach((containerTallas) => {
        containerTallas.style.display = "none";
        containerTallas.style.opacity = "0";
      });

      document.querySelectorAll(".div-block-67").forEach((containerInfo) => {
        containerInfo.style.display = "flex";
        containerInfo.style.opacity = "1";
      });
    }
  });
});

(function () {
  var deadline = "2024/09/09 16:00";
  function pad(num, size) {
    var s = "0" + num;
    return s.substr(s.length - size);
  }
  // fixes "Date.parse(date)" on safari
  function parseDate(date) {
    const parsed = Date.parse(date);
    if (!isNaN(parsed)) return parsed;
    return Date.parse(date.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
  }
  function getTimeRemaining(endtime) {
    let total = parseDate(endtime) - Date.parse(new Date());
    let seconds = Math.floor((total / 1000) % 60);
    let minutes = Math.floor((total / 1000 / 60) % 60);
    let hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    let days = Math.floor(total / (1000 * 60 * 60 * 24));
    return { total, days, hours, minutes, seconds };
  }
  function timer(id, endtime) {
    let days = document.getElementById(id + "-days");
    let hours = document.getElementById(id + "-hours");
    let minutes = document.getElementById(id + "-minutes");
    let seconds = document.getElementById(id + "-seconds");
    var timeinterval = setInterval(function () {
      var time = getTimeRemaining(endtime);
      if (time.total <= 0) {
        clearInterval(timeinterval);
      } else {
        days.innerHTML = pad(time.days, 2);
        hours.innerHTML = pad(time.hours, 2);
        minutes.innerHTML = pad(time.minutes, 2);
        seconds.innerHTML = pad(time.seconds, 2);
      }
    }, 1000);
  }
  timer("js-timer", deadline);
})();

function horizontalLoop(items, config) {
  items = gsap.utils.toArray(items);
  config = config || {};
  let tl = gsap.timeline({
    repeat: config.repeat,
    paused: config.paused,
    defaults: { ease: "none" },
    onReverseComplete: () =>
      tl.totalTime(tl.rawTime() + tl.duration() * 100),
  }),
    length = items.length,
    startX = items[0].offsetLeft,
    times = [],
    widths = [],
    xPercents = [],
    curIndex = 0,
    pixelsPerSecond = (config.speed || 1) * 100,
    snap =
      config.snap === false
        ? (v) => v
        : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
    totalWidth,
    curX,
    distanceToStart,
    distanceToLoop,
    item,
    i;
  gsap.set(items, {
    // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
    xPercent: (i, el) => {
      let w = (widths[i] = parseFloat(
        gsap.getProperty(el, "width", "px")
      ));
      xPercents[i] = snap(
        (parseFloat(gsap.getProperty(el, "x", "px")) / w) * 100 +
        gsap.getProperty(el, "xPercent")
      );
      return xPercents[i];
    },
  });
  gsap.set(items, { x: 0 });
  totalWidth =
    items[length - 1].offsetLeft +
    (xPercents[length - 1] / 100) * widths[length - 1] -
    startX +
    items[length - 1].offsetWidth *
    gsap.getProperty(items[length - 1], "scaleX") +
    (parseFloat(config.paddingRight) || 0);
  for (i = 0; i < length; i++) {
    item = items[i];
    curX = (xPercents[i] / 100) * widths[i];
    distanceToStart = item.offsetLeft + curX - startX;
    distanceToLoop =
      distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
    tl.to(
      item,
      {
        xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
        duration: distanceToLoop / pixelsPerSecond,
      },
      0
    )
      .fromTo(
        item,
        {
          xPercent: snap(
            ((curX - distanceToLoop + totalWidth) / widths[i]) * 100
          ),
        },
        {
          xPercent: xPercents[i],
          duration:
            (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
          immediateRender: false,
        },
        distanceToLoop / pixelsPerSecond
      )
      .add("label" + i, distanceToStart / pixelsPerSecond);
    times[i] = distanceToStart / pixelsPerSecond;
  }
  function toIndex(index, vars) {
    vars = vars || {};
    Math.abs(index - curIndex) > length / 2 &&
      (index += index > curIndex ? -length : length); // always go in the shortest direction
    let newIndex = gsap.utils.wrap(0, length, index),
      time = times[newIndex];
    if (time > tl.time() !== index > curIndex) {
      // if we're wrapping the timeline's playhead, make the proper adjustments
      vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
      time += tl.duration() * (index > curIndex ? 1 : -1);
    }
    curIndex = newIndex;
    vars.overwrite = true;
    return tl.tweenTo(time, vars);
  }
  tl.next = (vars) => toIndex(curIndex + 1, vars);
  tl.previous = (vars) => toIndex(curIndex - 1, vars);
  tl.current = () => curIndex;
  tl.toIndex = (index, vars) => toIndex(index, vars);
  tl.times = times;
  tl.progress(1, true).progress(0, true); // pre-render for performance
  if (config.reversed) {
    tl.vars.onReverseComplete();
    tl.reverse();
  }
  return tl;
}
